module.exports = __webpack_public_path__ + "static/img/blog.1c46d5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo/blog.jpg
// module id = cwzX
// module chunks = 0